export class FilterCriteria {
  constructor(public sort = '', public sortOrder = 1, public limit = 30, public offset = 0) {
  }

  public toString(): string {

    const order = this.sortOrder === 1 ? 'ASC' : 'DESC'
    return `?limit=${this.limit}&offset=${this.offset}&sort=${this.sort}&sortOrder=${order}`
  }
}



// WEBPACK FOOTER //
// ./src/app/models/filter-criteria.ts